import React, { useRef } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { InsertFieldMenu } from "@/components/email/EmailBodyEditor";

// Subject input with an "Insert merge field" menu that inserts at the cursor.
export function SubjectFieldInput({ value, onChange, testId, label = "Subject" }) {
  const ref = useRef(null);
  const insert = (k) => {
    const v = value || "";
    const t = ref.current;
    const s = t?.selectionStart ?? v.length;
    const e = t?.selectionEnd ?? v.length;
    const tok = `{{${k}}}`;
    onChange(v.slice(0, s) + tok + v.slice(e));
    setTimeout(() => { if (t) { t.focus(); t.setSelectionRange(s + tok.length, s + tok.length); } }, 0);
  };
  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-1">
        <Label className="text-xs font-semibold">{label}</Label>
        <InsertFieldMenu onPick={insert} testId={`${testId}-insert-field`} exclude={["sender_signature"]} />
      </div>
      <Input ref={ref} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} />
    </div>
  );
}
